/**
 * 方法导出工具
 */

var window = require("./window.js");

var exportNamespaces = "tellhowdm";

module.exports = function() {
	if (!window[exportNamespaces]) {
		window[exportNamespaces] = {};
	}
	var doExport = function(funName) {
		window[exportNamespaces][funName] = require("../func/" + funName + ".js");
	};
	for (var i=0; i<arguments.length; i++) {
		var funName = arguments[i];
		doExport(funName);
		
	}
	
}



//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/support/exports.js
// module id = 1
// module chunks = 0